// 发病倾向数据由后端 module 列表直接返回，前端无需额外清洗。
export default function transformTendency(/* state */) {
    return;
}
